exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{\r\n    min-height: 200px;\r\n    background-color: #ccc;\r\n    text-align: center;\r\n    line-height: 200px;\r\n  }\r\n  .leftRs {\r\n      position: absolute;\r\n      margin: auto;\r\n      top: 0;\r\n      bottom: 0;\r\n      width: 50px;\r\n      height: 50px;\r\n      box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);\r\n      border-radius: 999px;\r\n      left: 0;\r\n  }\r\n\r\n  .rightRs {\r\n      position: absolute;\r\n      margin: auto;\r\n      top: 0;\r\n      bottom: 0;\r\n      width: 50px;\r\n      height: 50px;\r\n      box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);\r\n      border-radius: 999px;\r\n      right: 0;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/customers-slider/customers-slider.component.css
// module id = ../../../../../src/app/customers-slider/customers-slider.component.css
// module chunks = main